import Vue from 'vue'
import Router from 'vue-router'
import Form from '@/components/Form'
import Unsubscribe from '@/components/Unsubscribe'
import ThankYou from '@/components/ThankYou'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Form',
      component: Form
    },
    {
      path: '/odjava',
      name: 'Unsubscribe',
      component: Unsubscribe
    },
    {
      path: '/hvala',
      name: 'ThankYou',
      component: ThankYou
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      redirect: '/login'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js